import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

export const RootBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: '10rem',
    paddingRight: '10rem'
  }
}));

export const LogoBox = styled(Box)(({ theme }) => ({
  width: '5.5rem',
  img: {
    width: '100%',
    height: 'auto'
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    justifyContent: 'center',
    width: '10rem'
  }
}));

export const BodyContainer = styled(Container)(() => ({
  padding: '0 1rem 1.25rem'
}));

export const HeaderContainer = styled(Container)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
}));

export const TitleContainer = styled(Container)(({ theme }) => ({
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
  [theme.breakpoints.up('md')]: {
    paddingTop: '3rem'
  }
}));

export const ButtonContainer = styled(Container)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0
}));
